// extracted by mini-css-extract-plugin
export default {"status":"_3D_Wd8SY4MY1t8Lib7rJbK"};